import type { ChatOutputTarget } from "../../contract";

export const FAQ_MODULE_ID = "faq";
export const FAQ_ENTRY_MAXIMUM_COUNT = 100;
export const FAQ_ENTRY_NAME_MAX_LENGTH = 60;
export const FAQ_PATTERN_MAXIMUM_COUNT = 20;
export const FAQ_PATTERN_MAX_LENGTH = 80;
export const FAQ_ANSWER_MAX_LENGTH = 500;
export const FAQ_COOLDOWN_MAXIMUM_SECONDS = 86_400;
export const FAQ_COOLDOWN_MINIMUM_SECONDS = 30;
export const FAQ_USER_COOLDOWN_MAXIMUM_SECONDS = 86_400;
export const FAQ_GAME_MAXIMUM_COUNT = 10;
export const FAQ_MINIMUM_TIERS = ["everyone", "subscriber", "vip", "moderator", "broadcaster"] as const;

export type FaqMinimumTier = typeof FAQ_MINIMUM_TIERS[number];

export type FaqMatcher =
  | { type: "keywords"; patterns: readonly string[] }
  | { type: "regex"; pattern: string };

export type FaqMutationMatcher = FaqMatcher;

export interface FaqGame {
  id: string;
  name: string;
  boxArtUrlTemplate?: string;
}

export interface FaqEntry {
  id: string;
  name: string;
  enabled: boolean;
  matcher: FaqMatcher;
  answerText: string;
  minimumTier: FaqMinimumTier;
  cooldownSeconds: number;
  userCooldownSeconds: number;
  games: readonly FaqGame[];
  chatTarget: ChatOutputTarget | null;
  order: number;
  revision: number;
  lastUsedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface FaqMutationInput {
  name: string;
  enabled: boolean;
  matcher: FaqMutationMatcher;
  answerText: string;
  minimumTier: FaqMinimumTier;
  cooldownSeconds: number;
  userCooldownSeconds: number;
  games: readonly FaqGame[];
  chatTarget: ChatOutputTarget | null;
}

export interface FaqMatch {
  entry: FaqEntry;
  matchedPattern: string;
}

export interface FaqMatchResult {
  match: FaqMatch | null;
  reason: "matched" | "no_match" | "command_prefix";
}
